export type FSGLNode = {
  name: string;
  glCode?: string | null;
  total: number;
  previousTotal: number;
  percentageOfSales?: number;
  changePercent: number;
  children: Record<string, FSGLNode>;
};

export type FSRawRow = {
  period: string;
  coaCode: string;
  coaName: string;
  parentCode: string;
  parentName: string;
  total: number;
  previousTotal: number | null;
};

export enum FSBreakdownOption {
  NONE = 'None',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  YEARLY = 'Yearly',
}

export enum FSComparisonOption {
  PREVIOUS_YEAR = 'previous_year',
  PREVIOUS_PERIOD = 'previous_period',
  NONE = 'none',
}

export enum FSDataSource {
  TOTAL_SALES = 'Total Sales',
  COGS = 'COGS',
  FOOD_COST = 'Food Cost',
  POUR_COST = 'Pour Cost',
  LABOR_COST = 'Labor Cost',
  EXPENSES = 'Expenses',
  OTHER_INCOME = 'Other Income',
  TAXES = 'Taxes',
  ACCOUNTS_PAYABLE = 'Accounts Payable',
  ACCOUNTS_RECEIVABLES = 'Accounts Receivables',
  GROSS_PROFIT = 'Gross Profit',
  EBIT = 'EBIT',
  NET_PROFIT = 'Net Profit',
  OPERATING_EXPENSES = 'Operating Expenses',
  OPERATION_COSTS = 'Operation Costs',
  TOTAL_EXPENSES = 'Total Expenses',
  UNEXPLAINED_INCOME = 'Unexplained Income',
  UNEXPLAINED_EXPENSE = 'Unexplained Expense',
}

export enum FinancialStatementScreen {
  DASHBOARD = 'DASHBOARD',
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  KPI_SNAPSHOT = 'KPI_SNAPSHOT',
  ONLY_SALES = 'ONLY_SALES',
}

export enum PLExportAS {
  PDF = 'PDF',
  EXCEL = 'EXCEL',
}

export enum PLExportOption {
  FULLY_EXPANDED = 'Fully expanded',
  FULLY_COLLAPSED = 'Fully collapsed',
  AS_DISPLAYED = 'As displayed',
}

export const DATE_FORMAT_yyyy_MM_dd = 'yyyy-MM-dd';
